import router from './router'
import { getToken } from '@/store/local/auth'
import { Message } from 'element-ui'

const whiteList = [
  '/','/store/entry','/store/entry/loginPwd','/store/entry/loginEmail','/store/entry/forgottenPwd','/store/entry/loginQRCode',
  '/store/dashboard','/store/dashboard/profile','/store/dashboard/password','/store/dashboard/phone','/store/dashboard/QRCode',
] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path.startsWith('/store/entry')) {
      // if is logged in, redirect to the home page
      next({ path: '/store/dashboard' })
    }
    next()
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) != -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      Message({
        message: '尚未登录',
        type: 'error',
        duration: 5 * 1000
      })
      next(`/store/entry?redirect=${to.path}`)
    }
  }
})

// router.afterEach(() => {
// })
